import MuiThemeProvider from '@trinity/chat-components/components/Theme/MuiThemeProvider.js';
import { ActiveScopeSync } from '@trinity/chat-components/containers/ActiveScope/ActiveScopeSync.js';
import { ChatWelcomeScreenContainer } from '@trinity/chat-components/containers/BrandInsights/ChatWelcomeScreen.Container.js';
import { QueryDownloaderContainer } from '@trinity/chat-components/containers/QueryDownloader/QueryDownloader.Container.js';
import FileUploadsProgressContainer from '@trinity/chat-components/containers/WorkspaceFileUpload/Upload.Progress.js';
import FileUploadsState from '@trinity/chat-components/containers/WorkspaceFileUpload/Upload.State.js';
import { AppReadyStateContainer } from '@/containers/AppReadyState';
import { AppStateEffectContainer } from '@/containers/AppStateEffect';
import { ChatCompatabilityProvider } from '@/containers/ChatCompatability/Chat.Compatability.Container';
import { AppThemingContainer } from '../AppTheming';
import { BrandInsightsContainer } from '../ChatCompatability/BrandInsights';
import { UserApplicationsContainer } from '../UserApplications/UserApplications';
import { UserBrandsContainer } from '../UserBrands/UserBrands';
import { ApplicationPolicyStateProvider } from './ApplicationPolicyStateProvider';

export const AppSubscriber = (props: ChildrenProps) => {
  return (
    <AppReadyStateContainer>
      <UserBrandsContainer>
        <UserApplicationsContainer>
          <ActiveScopeSync />
          <ApplicationPolicyStateProvider>
            <AppStateEffectContainer>
              <AppThemingContainer>
                <ChatCompatabilityProvider>
                  <QueryDownloaderContainer>
                    <MuiThemeProvider>
                      <FileUploadsState>
                        <ChatWelcomeScreenContainer>
                          <BrandInsightsContainer>
                            <FileUploadsProgressContainer>
                              {props.children}
                            </FileUploadsProgressContainer>
                          </BrandInsightsContainer>
                        </ChatWelcomeScreenContainer>
                      </FileUploadsState>
                    </MuiThemeProvider>
                  </QueryDownloaderContainer>
                </ChatCompatabilityProvider>
              </AppThemingContainer>
            </AppStateEffectContainer>
          </ApplicationPolicyStateProvider>
        </UserApplicationsContainer>
      </UserBrandsContainer>
    </AppReadyStateContainer>
  );
};
